import { useEffect, useRef } from "react";
import { BreadCrumb } from "primereact/breadcrumb";

import { useBreadcrumbContextOptional } from "../../contexts/Breadcrumb/BreadcrumbProvider";
import { INTERNAL_ROUTES } from "../../../constants/routes";
import { useSmartNavigation } from "../../../helpers/navigation";

import S from "./PageBreadcrumb.module.scss";

/**
 * Renders breadcrumbs inline within the page content (below the navbar).
 * Only renders when the current breadcrumb display mode is "page".
 * Pages using `useBreadcrumb({ ..., display: "page" })` should include
 * this component as the first element in their render output.
 */
export function PageBreadcrumb() {
  const breadcrumbCtx = useBreadcrumbContextOptional();
  const { navigateTo } = useSmartNavigation();
  const containerRef = useRef<HTMLDivElement>(null);

  // WCAG fix: PrimeReact BreadCrumb renders separator <li role="separator"> inside <ol>,
  // which is invalid. Removing the role restores the natural listitem semantics.
  useEffect(() => {
    containerRef.current
      ?.querySelectorAll<HTMLLIElement>('li.p-menuitem-separator[role="separator"]')
      .forEach(li => li.removeAttribute("role"));
  });

  if (!breadcrumbCtx || breadcrumbCtx.display !== "page" || !breadcrumbCtx.breadcrumbs) {
    return null;
  }

  const defaultHome = {
    label: INTERNAL_ROUTES.Learn.name,
    command: () => navigateTo(INTERNAL_ROUTES.Learn.route),
  };

  return (
    <div className={S.pageBreadcrumb} ref={containerRef}>
      <BreadCrumb
        model={breadcrumbCtx.breadcrumbs}
        home={breadcrumbCtx.homeItem ?? defaultHome}
        pt={{ root: { className: S.breadcrumbRoot } }}
      />
    </div>
  );
}
